const KEY = 'hbb:promoCode';

function canUseLS() {
  if (typeof window === 'undefined') return false;
  try { const t='__t__'; localStorage.setItem(t,t); localStorage.removeItem(t); return true; }
  catch { return false; }
}

export function savePromoCode(code) {
  if (canUseLS()) localStorage.setItem(KEY, code);
}
export function getPromoCode() {
  return canUseLS() ? localStorage.getItem(KEY) : null;
}
export function removePromoCode() {
  if (canUseLS()) localStorage.removeItem(KEY);
}
export function setNotShowDate(code, days) {
  // Used to avoid showing the promocode footer again and again - 3 days expiration
  if (canUseLS()) {
    const now = new Date();
    const expire = new Date(now.getFullYear(), now.getMonth(), now.getDate() + days);
    localStorage.setItem(`${KEY}:${code}:notShow`, expire.toISOString());
    return expire;
  }
  return null;
}
export function getNotShowDate(code) {
  if (!canUseLS()) return null;
  const dateStr = localStorage.getItem(`${KEY}:${code}:notShow`);
  if (!dateStr) return null;
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    localStorage.removeItem(`${KEY}:${code}:notShow`);
    return null;
  }
  return date;
}

export default { savePromoCode, getPromoCode, removePromoCode, setNotShowDate, getNotShowDate };
